const getSpaId = () => {
  const spaId = document.getElementById('root')?.getAttribute('data-spaId');
  if (!spaId && process.env.NODE_ENV !== 'test') {
    console.warn(new Error('Spa Id is not set'));
    return null;
  }
  return spaId;
};

export default getSpaId;
